import React from 'react';

import { GAP_UNIT_SIZE } from '../../constants';

export interface ISpacerProps {
    size?: number;
    dir?: 'horizontal' | 'vertical';
    grow?: boolean;
}

export const Spacer = ({ size = 0, dir = 'vertical', grow }: ISpacerProps) => {
    return (
        <div
            style={{
                ...(dir === 'horizontal' ? { width: size * GAP_UNIT_SIZE } : { height: size * GAP_UNIT_SIZE }),
                flex: grow ? 1 : undefined,
            }}
        />
    );
};
